import { provideZoneChangeDetection } from "@angular/core";
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from 'app/app.component';
import { appConfig } from 'app/app.config';
import { Buffer } from 'buffer';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import localeEn from '@angular/common/locales/en';
import localeEs from '@angular/common/locales/es';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

// Importar locales do Moment.js
import 'moment/locale/pt-br';
import 'moment/locale/es';
import 'moment/locale/en-gb';

(window as any).Buffer = Buffer;

registerLocaleData(localePt);
registerLocaleData(localeEn);
registerLocaleData(localeEs);

bootstrapApplication(AppComponent, {...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers]}).catch((err) =>
  console.error(err)
);
